// src/app/personal-dashboard/personal-dashboard.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-personal-dashboard',
  templateUrl: './personal-dashboard.component.html',
  styleUrls: ['./personal-dashboard.component.scss']
})
export class PersonalDashboardComponent {

  
  constructor() { }

 

}
